export enum PlatformToastMessageType {
    SUCCESS = 'SUCCESS', ERROR = 'ERROR', INFO = 'INFO', WARNING = 'WARNING'
}
